module.exports = __webpack_public_path__ + "static/media/06.07a22b13.mp3";